import React from 'react';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';

import { ICurrency } from 'src/apis/common';
import { Form, Input } from 'antd';

export interface IProps extends FormComponentProps
{
  currency: ICurrency;
  // The form field ID.
  fieldId: string;
  maxAmount: number;
  formItemProps?: FormItemProps;
  requireNonzero?: boolean;
}

/**
 * An Ant Form input for a currency value.
 */
const CurrencyFormInput: React.FC<IProps> = (props) => {
  const { getFieldDecorator } = props.form;
  const { requireNonzero } = props;

  const validateAmount = (rule: any, value: any, callback: any) => {
    const currentValue = parseFloat(value);
    const reg = /^-?[0-9]*(\.[0-9]*)?$/;
    if (value !== undefined && !reg.test(value)) {
      // Some value provided, but it's non-numeric
      callback(new Error('Please enter a numeric value (no commas)'))
    } else if (requireNonzero && (Number.isNaN(currentValue) || currentValue === 0)) {
      // We require a non-zero value, but either one wasn't provided, or it was zero
      callback(new Error('Please enter a valid amount'))
    } else if (currentValue < 0.0) {
      // We do not allow negative values
      callback(new Error('Please enter a valid amount'))
    } else if (currentValue > props.maxAmount) {
      // We should prevent over-refunding
      callback(new Error('Amount too high'))
    } else {
      callback();
    }
  }

  return <Form.Item {...props.formItemProps}>
    {getFieldDecorator(props.fieldId, {
    rules: [
      { validator: validateAmount }
    ]
  })(<Input prefix={props.currency.symbol} />)}
  </Form.Item>;
};

export default CurrencyFormInput;
